<template>
  <footer class="bg-white py-6">
    <div class="mx-auto w-full max-w-screen-xl px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col sm:flex-row sm:justify-between items-center text-center sm:text-left">
        <div class="mb-6 sm:mb-0 flex items-center">
          <a href="#" class="flex items-center">
            <img src="/images/logo.svg" class="h-12 mr-2" alt="logo" />
          </a>
        </div>
        <div class="flex space-x-4">
          <a href="https://www.facebook.com/profile.php?id=61553140545332" class="hover:underline">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1877F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3.2c-1.7 0-3 .5-4 1.5s-1.4 2.3-1.4 3.8v3H6v4h3.4v9h4v-9H17l1-4h-4v-2c0-.6.2-1.1.6-1.4s.9-.6 1.4-.6H18V2z"/>
            </svg>
          </a>
          <a href="https://www.linkedin.com" class="hover:underline">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0A66C2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="3" ry="3"/>
              <path d="M8 11v6M8 8v0M16 17v-3.5a2 2 0 0 0-4 0V17"/>
            </svg>
          </a>
        </div>
      </div>

      <div class="mt-4 text-center sm:text-left">
        <ul class="flex flex-wrap justify-center sm:justify-start space-x-4 text-sm text-gray-500">
          <li><button @click="scrollToTextComponent" class="hover:underline">About us</button></li>
          <li><router-link to="/gallery" class="hover:underline">Our projects</router-link></li>
          <li><a href="#" @click.prevent="showPrivacyPolicy = true" class="hover:underline">Privacy Policy</a></li>
        </ul>
      </div>

      <hr class="my-4 border-gray-200" />
      <div class="text-center text-sm text-gray-500">
        <span>© 2023 ProjectSpot. All rights reserved.</span>
        <br class="sm:hidden" />
        <span> ProjectSpot is the data controller. Your personal data is processed in accordance with our privacy policy.</span>
      </div>
    </div>

    <!-- Privacy Policy Modal -->
    <div v-if="showPrivacyPolicy" class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4">
      <div class="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full text-left relative mt-8 mb-8">
        <h2 class="text-xl font-bold text-gray-900 mb-4">Privacy Policy</h2>
        <div class="text-gray-700 text-sm overflow-auto max-h-[80vh]">
          <p>
            1. General Information<br>
            This policy applies to the website projectspot.pl.<br>
            The site operator and personal data administrator is: Szymon Chossa, Roosevelta 6/7, Poznań 60-880.<br>
            Email contact: biuro@projectspot.pl.<br>
            The operator is the administrator of your personal data provided voluntarily on the website.<br>
            Data is used for:<br>
            - Newsletter distribution<br>
            - Comment system operation<br>
            - Online chat handling<br>
            - Handling contact form inquiries<br>
            - Providing services<br>
            - Presenting offers or information<br><br>
            2. Data protection methods<br>
            - SSL certificate for login and form data.<br>
            - Encrypted personal data in databases.<br>
            - Hashed user passwords.<br>
            - Regular backups and updates.<br><br>
            3. Hosting<br>
            - The website is hosted by: home.pl.<br><br>
            4. Your rights<br>
            - You can access, correct, delete or transfer your data.<br>
            - You can object to processing.<br>
            - You can lodge a complaint with the data protection authority.<br><br>
            5. Form data<br>
            - The website collects user-submitted data voluntarily.<br>
            - It may store technical data and connection details.<br><br>
            6. Administrator logs<br>
            - User behavior may be logged for administrative purposes.<br><br>
            7. Marketing techniques<br>
            - Google Analytics and Facebook Pixel are used for traffic analysis and remarketing.<br><br>
            8. Cookies<br>
            - Cookies are used for session handling and statistics.<br>
            - You can manage cookies in your browser.<br><br>
          </p>
        </div>
        <button @click="showPrivacyPolicy = false" class="mt-4 bg-[#E9A53D] text-white px-4 py-2 rounded hover:bg-orange-700">
          Close
        </button>
      </div>
    </div>
  </footer>
</template>

<script>
import { useRouter } from "vue-router";
import { nextTick } from "vue";

export default {
  data() {
    return {
      showPrivacyPolicy: false,
    };
  },
  setup() {
    const router = useRouter();

    const scrollToTextComponent = () => {
      router.push('/').then(() => {
        nextTick(() => {
          const textComponent = document.getElementById("text-component");
          if (textComponent) {
            textComponent.scrollIntoView({ behavior: "smooth" });
          }
        });
      });
    };

    return { scrollToTextComponent };
  },
};
</script>
